import cf from './cf';
import i1zv3 from './i1zv3_20211024';

export default class i1zv3b extends i1zv3 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: '使用状況', // サイネージ
      class: 'i1zv3b',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
